import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import LoadingStates from "../constants/states/LoadingStates";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";


class GoogleAPILibState {
    constructor(loadingState) {
        this.loadingState = loadingState;
    }

    equals(other) {
        return this.loadingState === other.loadingState;
    }
}

class ImmutableGoogleAPILibStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    build() {
        return Object.freeze(new GoogleAPILibState(this.loadingState));
    }
}


class GoogleAPILibStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, ImmutableGoogleAPILibStateBuilder);
        this.subscribeToEvent(ActionResultEvents.GOOGLE_LIB_LOADED, this.handleLibLoaded);
        this.subscribeToEvent(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, this.handleLibLoadStart);
    }

    handleLibLoadStart = (topic, data) => {
        return new ImmutableGoogleAPILibStateBuilder()
            .setLoadingState(LoadingStates.LOADING)
            .build()
    };

    handleLibLoaded = (topic, data) => {
        return new ImmutableGoogleAPILibStateBuilder()
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .build()
    };



}

export default new GoogleAPILibStore();